import { createSlice } from '@reduxjs/toolkit';
import { RootState } from './store';

const initialState = false;

export const partiallyLoaderSlice = createSlice({
  name: 'partiallyLoader',
  initialState,
  reducers: {
    startPartiallyLoading: () => true,
    stopPartiallyLoading: () => false,
  },
});

// Action creators are generated for each case reducer function
export const { startPartiallyLoading, stopPartiallyLoading } =
  partiallyLoaderSlice.actions;

export const getPartialLoadingState = (state: RootState) =>
  state.partiallyLoader;

export default partiallyLoaderSlice.reducer;
